import api from '@/api'

const state = {
  kpis: null,
  abcAnalysis: null,
  dinAnalysis: null,
  lowStockProducts: [],
  rotationAnalysis: [],
  demandPredictions: [],
  loading: false,
  error: null
}

const getters = {
  getKPIs: state => state.kpis,
  getABCAnalysis: state => state.abcAnalysis,
  getDINAnalysis: state => state.dinAnalysis,
  getLowStockProducts: state => state.lowStockProducts,
  getRotationAnalysis: state => state.rotationAnalysis,
  getDemandPredictions: state => state.demandPredictions,
  isLoading: state => state.loading,
  getError: state => state.error
}

const actions = {
  async getKPIs({ commit }, filters = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.getKPIs(filters)
      commit('SET_KPIS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getABCAnalysis({ commit }, filters = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.getABCAnalysis(filters)
      commit('SET_ABC_ANALYSIS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getDINAnalysis({ commit }, filters = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.getDINAnalysis(filters)
      commit('SET_DIN_ANALYSIS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getLowStockProducts({ commit }, filters = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.getLowStockProducts(filters)
      commit('SET_LOW_STOCK_PRODUCTS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getRotationAnalysis({ commit }, { days = 30, ...filters } = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.getRotationAnalysis({ days, ...filters })
      commit('SET_ROTATION_ANALYSIS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async getDemandPredictions({ commit }, filters = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.getDemandPredictions(filters)
      commit('SET_DEMAND_PREDICTIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async recalculatePredictions({ commit }, filters = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.recalculatePredictions(filters)
      commit('SET_DEMAND_PREDICTIONS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async exportAnalytics({ commit }, { format = 'xlsx', filters = {} } = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await api.exportAnalytics({ format, ...filters })
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.message)
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },

  SET_ERROR(state, error) {
    state.error = error
  },

  SET_KPIS(state, kpis) {
    state.kpis = kpis
  },

  SET_ABC_ANALYSIS(state, analysis) {
    state.abcAnalysis = analysis
  },

  SET_DIN_ANALYSIS(state, analysis) {
    state.dinAnalysis = analysis
  },

  SET_LOW_STOCK_PRODUCTS(state, products) {
    state.lowStockProducts = products
  },

  SET_ROTATION_ANALYSIS(state, analysis) {
    state.rotationAnalysis = analysis
  },

  SET_DEMAND_PREDICTIONS(state, predictions) {
    state.demandPredictions = predictions
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
} 